import { atom, selector } from 'recoil';
import { DisplayedSelectedItem } from '@ui/resource-modal/container';
import { CouponCodeLabel } from '@components/campaign/offer-settings';
import { CouponCodeResourceItem, CouponCodesData } from '../../types';
import { selectedCampaignSelector } from '../campaign';

export const couponCodesState = atom<CouponCodeResourceItem[]>({
  default: [],
  key: 'couponCodesState',
});

export const unsavedCouponCodesState = atom<CouponCodeResourceItem[]>({
  default: [],
  key: 'unsavedCouponCodesState',
});

export const couponCodesDataSelector = selector<CouponCodesData>({
  get: ({ get }) => {
    const couponCodes = get(couponCodesState);
    const unsavedCouponCodes = get(unsavedCouponCodesState);

    const couponCodesData: CouponCodesData = {};

    [...couponCodes, ...unsavedCouponCodes].forEach((couponCode) => {
      couponCodesData[couponCode.id.toString()] = {
        ...couponCode,
        id: parseInt(couponCode.id),
      };
    });

    return couponCodesData;
  },
  key: 'couponCodesDataSelector',
});

export const selectedCouponCodeListSelector = selector<DisplayedSelectedItem[]>(
  {
    get: ({ get }) => {
      const unsavedCouponCodes = get(unsavedCouponCodesState);
      const selectedCampaign = get(selectedCampaignSelector);

      let couponCouponCodesToParse = [...unsavedCouponCodes];

      if (
        selectedCampaign?.trigger.settings &&
        'couponCodes' in selectedCampaign.trigger.settings
      ) {
        const couponCodesFromCampaign =
          selectedCampaign.trigger.settings.couponCodes.map((couponCode) => {
            return {
              ...couponCode,
              id: couponCode.id.toString(),
            };
          });

        couponCouponCodesToParse = [
          ...couponCouponCodesToParse,
          ...couponCodesFromCampaign,
        ];
      }

      return couponCouponCodesToParse.map((couponCode) => {
        return {
          id: couponCode.id.toString(),
          item: <CouponCodeLabel>{couponCode.code}</CouponCodeLabel>,
        };
      });
    },
    key: 'selectedCouponCodeListSelector',
  },
);
